export const PXDX = "PxDx";
export const DEMOGRAPHICS = "Demographics/Age";
export const FREQUENCY = "Frequency";
export const INCOMPATIBILITY = "Incompatibility";
export const PRIMARY_REQUIRED = "Primary Required";
export const PLACE_OF_SERVICE = "POS";
export const PRIOR_AUTH = "Prior Auth";
export const UNENFORCEABLE = "Unenforceable";
export const RULE_OVERRIDES = "Rule Overrides (exclusions)";

export const DEPENDENCY = "Dependency";
export const HISTORY_TRANSLATION = "History";
//export const PLACE_OF_SERVICE = "Place of Service";
export const UNLISTED_PA = "Unlisted PA";

export const PXDX_RFG = "pxdxmatching";
export const DEMOGRAPHICS_RFG = "DemoGraphicRuleFlow";
export const DEPENDENCY_RFG = "PrimaryRequired";
export const INCOMPATIBILITY_RFG = "MESameClaimRuleFlowGroup";
export const INCOMPATIBILITY_RFG_MEFIRESTCOME = "MeFirstCome";
export const PLACE_OF_SERVICE_RFG = "PlaceOfServiceRuleFlowGroup";
export const UNLISTED_PA_RFG = "PxCodeLookupFlwGrp";
export const DUHS_RFG = "dosunithistorysearch";
export const CFUS_RFG = "claimfrequnitsearch";
export const CHUS_RFG = "claimhistoryunitsearch";

export const PXDX_RFG_TAB = ["pxdxmatching", "ExpAndInvestFlwGrp"];
export const DEMOGRAPHICS_RFG_TAB = ["DemoGraphicRuleFlow"];
export const DEPENDENCY_RFG_TAB = ["PrimaryRequired"];
export const HISTORY_TRANSLATION_RFG_TAB = [
  DUHS_RFG,
  CFUS_RFG,
  CHUS_RFG,
  "History", //Per Nicole this is a place holder so new rows added to the history table will appear in the grid.
];
export const INCOMPATIBILITY_RFG_TAB = ["MESameClaimRuleFlowGroup"];
export const PLACE_OF_SERVICE_RFG_TAB = ["PlaceOfServiceRuleFlowGroup"];
export const UNLISTED_PA_RFG_TAB = ["PxCodeLookupFlwGrp"];

export const POLICY_STATUS_NEW = "NEW";
export const POLICY_STATUS_VARIANCE = "VARIANCE";
export const POLICY_STATUS_NEW_OR_VARIANCE = "NEW_OR_VARIANCE";
export const POLICY_STATUS_EDIT = "EDIT";
export const POLICY_STATUS_DELETED = "DELETED";
export const FAILED_VALIDATION = "FAILED_VALIDATION";

export const COVERAGE_CRITERIA_ALL = "All";
export const ALL = "All";
export const MISSING_CC = "Missing CC";

export const tabOrder = new Map([
  [PXDX, 0],
  [DEMOGRAPHICS, 1],
  [FREQUENCY, 2],
  [INCOMPATIBILITY, 3],
  [PRIMARY_REQUIRED, 4],
  [PLACE_OF_SERVICE, 5],
  [PRIOR_AUTH, 6],
  [UNENFORCEABLE, 7],
  [RULE_OVERRIDES, 8],
]);

export const TAB_RULE_UNIT_CONFIG = {
  [tabOrder.get(PXDX)]: {
    ruleUnitType: "PDM",
    ruleUnitTabName: PXDX,
    tabSuffix: "pdm",
  },
};

export const getRuleUnitConfigForTab = (tabValue) =>
  TAB_RULE_UNIT_CONFIG[tabValue] || null;

export const getRuleUnitTabSuffix = (tabValue) =>
  getRuleUnitConfigForTab(tabValue)?.tabSuffix || null;

export const isRuleUnitApiEnabledForTab = (tabValue) =>
  Boolean(getRuleUnitTabSuffix(tabValue));

export const SCENARIO_OPTIONS = [
  "One unit per Lifetime",
  "One unit per z days",
  "x units per z days",
  "Y units per DOS",
  "CPT Code Pair Incompatibility",
  "CPT Code Pair Requirements",
];

export const TIME_FRAME_OPTIONS = [
  { key: "Days", value: "Day(s)" },
  { key: "Weeks", value: "Week(s)" },
  { key: "Months", value: "Month(s)" },
  { key: "Years", value: "Year(s)" },
];

export const INIT_POLICY_RULES = {
  [PXDX]: [],
  [DEPENDENCY]: [],
  [DEMOGRAPHICS]: [],
  [HISTORY_TRANSLATION]: [],
  [INCOMPATIBILITY]: [],
  [PLACE_OF_SERVICE]: [],
  [UNLISTED_PA]: [],
};

export const DxCantHaveValue = {
  value: "DxCantHave",
  label: "Can't Have",
};

export const DxCantHavePrimaryValue = {
  value: "DxCantHavePrimary",
  label: "Dx Can't Have Primary",
};

export const DxCantHaveSecondaryValue = {
  value: "DxCantHaveSecondary",
  label: "Dx Can't Have Secondary",
};

export const initialLobValues = [
  { key: "All", value: "All" },
  { key: "Global", value: "Global" },
];
export const validationOptions = [
  { label: ALL, selected: false, value: ALL },
  { label: "Failed Validation", selected: false, value: FAILED_VALIDATION },
];

export const BLANK_RULE = {
  ruleName: "",
  cc: "",
  version: "1.0",
  procedures: "",
  ruleType: "",
  diagnoses: false,
  modifiers: false,
  dateLOB: "",
  rationale: false,
};

export const LOB_CONFIG_DATA = {
  LobConfigKey: 0,
  effectiveDate: null,
  endDate: null,
};
